import { round } from "lodash";

export default {
    methods: {
        round: round
    }
}